import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "hd" }
const _hoisted_2 = {
  key: 0,
  class: "hd-info"
}
const _hoisted_3 = {
  key: 0,
  class: "hd-bar"
}
const _hoisted_4 = { class: "hd-chips" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "hd-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeView = _resolveComponent("WelcomeView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Se încarcă..."))
      : (_ctx.available.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.available.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.available, (d) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: d.modul,
                        class: _normalizeClass(["hd-chip", { active: _ctx.current === d.modul }]),
                        onClick: ($event: any) => (_ctx.current = d.modul)
                      }, _toDisplayString(d.text), 11, _hoisted_5))
                    }), 128))
                  ]),
                  _createElementVNode("button", {
                    class: "hd-default",
                    disabled: _ctx.isDefault,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setDefault && _ctx.setDefault(...args)))
                  }, [
                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "dx-icon dx-icon-pin" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.isDefault ? 'Este implicit' : 'Setează ca implicit'), 1)
                  ], 8, _hoisted_6)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent)))
            ])
          ], 64))
        : (_openBlock(), _createBlock(_component_WelcomeView, { key: 2 }))
  ]))
}